import {
  set,
  reactive,
  computed
} from "@nuxtjs/composition-api";
import { useUiHelpers } from "@wemade-vsf/composables";
import { getFilterConfig } from "../../config/FiltersConfig";
import { FilterTypeEnum } from "../../config/config";
const state = reactive({
  selectedFilters: {},
  removableFilters: []
});
function useFilters() {
  const { getFacetsFromURL } = useUiHelpers();
  const getSelectedFiltersFromUrl = () => {
    const selectedFilterValues = {};
    const { filters } = getFacetsFromURL();
    Object.keys(filters).forEach((filter) => {
      selectedFilterValues[filter] = filters[filter];
    });
    return selectedFilterValues;
  };
  state.selectedFilters = getSelectedFiltersFromUrl();
  const isFilterSelected = (name, value) => {
    var _a;
    const selected = ((_a = state.selectedFilters[name]) != null ? _a : []).find((selectedValue) => selectedValue === value);
    return selected != null ? selected : "";
  };
  const removeFilter = (attrCode, valToRemove) => {
    if (!state.selectedFilters[attrCode])
      return;
    state.selectedFilters[attrCode] = state.selectedFilters[attrCode].filter((value) => value !== valToRemove);
  };
  const selectFilter = (filter, option, aggregate = true) => {
    var _a;
    const config = getFilterConfig(filter);
    if (!state.selectedFilters[filter.attribute_code]) {
      set(state.selectedFilters, filter.attribute_code, []);
    }
    if (config.type === FilterTypeEnum.RADIO || config.type === FilterTypeEnum.YES_NO || config.type === FilterTypeEnum.RANGE || !aggregate) {
      state.selectedFilters[filter.attribute_code] = [option.value];
      return;
    }
    if (state.selectedFilters[filter.attribute_code].find((f) => f === option.value)) {
      state.selectedFilters[filter.attribute_code] = (_a = state.selectedFilters[filter.attribute_code]) == null ? void 0 : _a.filter((f) => f !== option.value);
      return;
    }
    state.selectedFilters[filter.attribute_code].push(String(option.value));
  };
  const getRemovableFilters = (filters, selected) => {
    const result = [];
    filters.forEach((filter) => {
      filter.options.forEach((option) => {
        var _a;
        if (((_a = selected[filter.attribute_code]) != null ? _a : []).includes(option.value)) {
          const filterConfig = getFilterConfig(filter);
          result.push({
            id: filter.attribute_code,
            name: filter.label,
            label: option.label,
            value: option.value,
            type: filterConfig.type
          });
        }
      });
    });
    state.removableFilters = result;
    return result;
  };
  const clearSelectedFilters = () => {
    state.selectedFilters = {};
  };
  return {
    getSelectedFiltersFromUrl,
    isFilterSelected,
    removeFilter,
    selectFilter,
    clearSelectedFilters,
    selectedFilters: computed(() => state.selectedFilters),
    removableFilters: computed(() => state.removableFilters),
    getRemovableFilters
  };
}
var useFilters_default = useFilters;
export {
  useFilters_default as default,
  useFilters
};
